import axios from "axios";
import { API } from "@/contexts/AuthContext";

const client = axios.create({ baseURL: API, withCredentials: true });

export const crmApi = {
  listLeads: (params) => client.get("/crm/leads", { params }).then((r) => r.data),
  getLead: (id) => client.get(`/crm/leads/${id}`).then((r) => r.data),
  updateLead: (id, body) => client.put(`/crm/leads/${id}`, body).then((r) => r.data),
  deleteLead: (id) => client.delete(`/crm/leads/${id}`).then((r) => r.data),
  addNote: (id, body) => client.post(`/crm/leads/${id}/notes`, { body }).then((r) => r.data),
  deleteNote: (leadId, noteId) => client.delete(`/crm/leads/${leadId}/notes/${noteId}`).then((r) => r.data),
  addTask: (id, task) => client.post(`/crm/leads/${id}/tasks`, task).then((r) => r.data),
  updateTask: (taskId, body) => client.patch(`/crm/tasks/${taskId}`, body).then((r) => r.data),
  deleteTask: (taskId) => client.delete(`/crm/tasks/${taskId}`).then((r) => r.data),
  listTasks: (params) => client.get("/crm/tasks", { params }).then((r) => r.data),
  listUsers: () => client.get("/crm/users").then((r) => r.data),
  createLead: (body) => client.post("/crm/leads", body).then((r) => r.data),
  dashboard: () => client.get("/crm/dashboard").then((r) => r.data),
  search: (q) => client.get("/crm/search", { params: { q } }).then((r) => r.data),
  meta: () => client.get("/crm/meta").then((r) => r.data),

  // Insights (admin)
  listInsights: () => client.get("/crm/insights").then((r) => r.data),
  getInsight: (id) => client.get(`/crm/insights/${id}`).then((r) => r.data),
  createInsight: (body) => client.post("/crm/insights", body).then((r) => r.data),
  updateInsight: (id, body) => client.put(`/crm/insights/${id}`, body).then((r) => r.data),
  deleteInsight: (id) => client.delete(`/crm/insights/${id}`).then((r) => r.data),
};

// Public (no auth)
export const publicApi = {
  listInsights: () => client.get("/insights").then((r) => r.data),
  getInsight: (slug) => client.get(`/insights/${slug}`).then((r) => r.data),
};

export const STAGES = [
  "New Enquiry",
  "Discovery Call Booked",
  "Consultation Complete",
  "Proposal Sent",
  "Awaiting Payment",
  "Active Client",
  "Completed",
  "Referral Opportunity",
  "Lost",
];

export const STAGE_STYLES = {
  "New Enquiry": "bg-slate-100 text-slate-800 dark:bg-slate-800/60 dark:text-slate-200 border-slate-200 dark:border-slate-700",
  "Discovery Call Booked": "bg-blue-50 text-blue-800 dark:bg-blue-900/30 dark:text-blue-200 border-blue-200 dark:border-blue-800/50",
  "Consultation Complete": "bg-indigo-50 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-200 border-indigo-200 dark:border-indigo-800/50",
  "Proposal Sent": "bg-amber-50 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200 border-amber-200 dark:border-amber-800/50",
  "Awaiting Payment": "bg-orange-50 text-orange-800 dark:bg-orange-900/30 dark:text-orange-200 border-orange-200 dark:border-orange-800/50",
  "Active Client": "bg-emerald-50 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-200 border-emerald-200 dark:border-emerald-800/50",
  "Completed": "bg-teal-50 text-teal-800 dark:bg-teal-900/30 dark:text-teal-200 border-teal-200 dark:border-teal-800/50",
  "Referral Opportunity": "bg-purple-50 text-purple-800 dark:bg-purple-900/30 dark:text-purple-200 border-purple-200 dark:border-purple-800/50",
  "Lost": "bg-rose-50 text-rose-800 dark:bg-rose-900/30 dark:text-rose-200 border-rose-200 dark:border-rose-800/50",
};

export const SERVICES = [
  "Golden Visa",
  "Residency Visas",
  "Business Setup",
  "Company Formation",
  "Relocation Planning",
  "Family Visas",
  "Property Investment",
  "Other",
];

export const SOURCES = [
  "website",
  "homepage",
  "golden-visa",
  "business-setup",
  "relocation",
  "contact-page",
  "google-search",
  "youtube",
  "instagram",
  "linkedin",
  "referral",
  "existing-client",
  "paid-advertising",
];

export const formatAED = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("en-AE", { style: "currency", currency: "AED", maximumFractionDigits: 0 }).format(v);
};

export const initialsOf = (nameOrEmail) => {
  const s = (nameOrEmail || "").trim();
  if (!s) return "?";
  const parts = s.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
};
